import {useMediaQuery, useTheme} from '@mui/material'

export {useBreakPoints} from '@hconnect/uikit/src/lib2'
export {useIsMobile} from '@hconnect/uikit/src/lib2'

export const useIsNarrow = () => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down('lg'))
}
